import { render, staticRenderFns } from "./EventActionsChart.vue?vue&type=template&id=e2f0406e"
import script from "./EventActionsChart.vue?vue&type=script&lang=js"
export * from "./EventActionsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports